import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomDeleteAiMappingSegmentationMutation } from "generated/graphql";

export const useDeleteAiMappingSegmentation = () => {
  const [mutation, { data, loading, error }] = useCustomDeleteAiMappingSegmentationMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "deleteAiMappingSegmentation" },
    { hideMessage: true }
  );
};
